/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-group-1 ul');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('#modalAddToCartError p').text(str);  
  jQuery('#modalAddToCartError').modal("toggle");
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        if(jQuery( window ).width() > 379) {
          Shopify.cartPopap(variant_id);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(jQuery( window ).width() > 379) {
            Shopify.cartPopapForm(variant_id);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var title = jQuery('.'+variant_id+':first .product_title').text();
  	jQuery('.productmsg').text('"'+title+'"');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var title = jQuery('.product-info__title h2').text();
	jQuery('.productmsg').text('"'+title+'"');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
			
          if (value.length) {
            jQuery(".cart-group-1").css({"display": "block"});
            jQuery(".cart-group-2").css({"display": "none"});
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {						
              if(i > 2){
                  return false;
              }
              jQuery('<li class="shopping-cart__item"><div class="shopping-cart__item__image pull-left"><a href="' + item.url + '"><img src="' + item.image + '" alt=""/></a></div><div class="shopping-cart__item__info"><div class="shopping-cart__item__info__title"><h2 class="text-uppercase"><a href="' + item.url + '">' + item.title + '</a></h2></div><div class="shopping-cart__item__info__price">' + Shopify.formatMoney(item.price, formatMoney) + '</div><div class="shopping-cart__item__info__qty">Qty: ' + item.quantity + '</div><div class="shopping-cart__item__info__delete"><a href="javascript:;" onclick="Shopify.removeItem(' + item.variant_id + ')" class="icon icon-clear"></a></div></div></li>').appendTo(table);
            });

          }
          else {
            jQuery(".cart-group-1").css({"display": "none"});
            jQuery(".cart-group-2").css({"display": "block"});
          }
        }
      });
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);
  changeHtmlValue(".badge--menu-counter", cart.item_count);
  changeHtmlValue(".header__cart__indicator", Shopify.formatMoney(cart.total_price, formatMoney));

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};